import React from 'react';
import styles from './TenureStats.module.css';

const formatTenure = (memberSinceDate) => {
  const now = new Date();
  let months = (now.getFullYear() - memberSinceDate.getFullYear()) * 12
    + (now.getMonth() - memberSinceDate.getMonth());
  if (now.getDate() < memberSinceDate.getDate()) months -= 1;
  if (months < 1) return { value: '<1', label: 'Month' };

  const years = Math.floor(months / 12);
  const remMonths = months % 12;
  if (years < 1) return { value: `${months}`, label: months === 1 ? 'Month' : 'Months' };
  if (remMonths === 0) return { value: `${years}y`, label: years === 1 ? 'Year' : 'Years' };
  return { value: `${years}y ${remMonths}m`, label: 'Member For' };
};

const TenureStats = ({ tenure, totalWorkouts, streak }) => {
  const memberSinceDate = new Date(tenure.member_since);
  const memberSince = memberSinceDate.toLocaleDateString();
  const { value, label } = formatTenure(memberSinceDate);

  return (
    <div className={styles.Grid}>
      <div className={styles.StatBox}>
        <p className={styles.Value}>{value}</p>
        <p className={styles.Label}>{label}</p>
        <p className={styles.SubLabel}>Since {memberSince}</p>
      </div>
      <div className={styles.StatBox}>
        <p className={styles.Value}>{totalWorkouts != null ? totalWorkouts : '-'}</p>
        <p className={styles.Label}>Workouts</p>
        {streak != null && streak > 0 && (
          <p className={styles.Streak}>Current streak: {streak}</p>
        )}
      </div>
    </div>
  );
};

export default TenureStats;
